/**
 * 다크 모드 서피스 토큰 (시맨틱 status·브랜드 슬롯과 분리)
 */

import { adjustHsl, contrastFg, deriveHeaderSort, hexToRgba } from 'styles/brandColorUtils';

/** @type {Record<string, unknown>} */
export const DARK_SURFACE_OVERRIDES = {
  white: '#1F2937',
  black: '#F9FAFB',
  navy: '#E5E7EB',
  secondary: '#111827',
  tertiary: '#1E3A5F',
  quaternary: '#111827',
  quinary: '#374151',
  senary: '#4B5563',
  septenary: '#9CA3AF',
  octonary: '#D1D5DB',
  nonary: '#E5E7EB',
  denary: '#F3F4F6',
  border: '#374151',
  borderLight: '#1F2937',
  sidebarDark: '#030712',
  text: {
    primary: '#F3F4F6',
    secondary: '#D1D5DB',
    tertiary: '#9CA3AF',
    white: '#FFFFFF',
  },
  background: {
    light: '#111827',
    medium: '#1F2937',
    dark: '#374151',
    white: '#1F2937',
    black: '#030712',
    default: '#0B1220',
    secondary: '#111827',
    tertiary: '#9CA3AF',
    quaternary: '#6B7280',
    quinary: '#4B5563',
    senary: '#1F2937',
    septenary: '#0F172A',
    input: '#1F2937',
    sidebar: '#0F172A',
    page: '#0B1220',
  },
  grid: {
    headerBg: '#1F2937',
    headerText: '#E5E7EB',
    /** 서피스와 근접 — 읽기전용 셀이 검게 덩어리져 보이지 않도록 */
    readonlyBg: '#1E293B',
    border: '#374151',
    emptyText: '#9CA3AF',
    stackDivider: '#4B5563',
  },
  gridInactive: {
    headerBg: '#111827',
    headerFg: '#E5E7EB',
  },
};

export const DARK_SHADOW_OVERRIDES = {
  sm: '0 1px 2px rgba(0, 0, 0, 0.35)',
  md: '0 2px 8px rgba(0, 0, 0, 0.4)',
  lg: '0 4px 16px rgba(0, 0, 0, 0.45)',
  card: '0 1px 3px rgba(0, 0, 0, 0.35)',
};

/**
 * 다크에서 soft 선택·hover를 어두운 tint로 보정
 * @param {Record<string, string>} slots
 * @returns {Record<string, string>}
 */
export function adaptBrandSlotsForDark(slots) {
  if (!slots?.primary) return slots;
  const primary = slots.primary;
  const softSelected = adjustHsl(primary, { s: 35, l: 22 });
  const softHover = adjustHsl(primary, { s: 28, l: 16 });
  const softLight = softSelected;
  const headerBg = slots.gridHeaderActive || primary;
  return {
    ...slots,
    primaryLight: softLight,
    tabHoverActive: softLight,
    focusRing: adjustHsl(primary, { s: 50, l: 42 }),
    gridRowSelected: softSelected,
    gridRowHover: softHover,
    gridCellSelected: hexToRgba(primary, 0.28),
    gridCellBlockBorder: slots.gridCellBlockBorder || '#F59E0B',
    gridHeaderActiveFg: contrastFg(headerBg),
    gridHeaderActiveSort: deriveHeaderSort(headerBg),
  };
}
